import { Divider, Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import { NavMenuItemType } from 'modules/app/types/navigation-menu.type';
import styles from './side-navigation-item.module.scss';

type SideNavMenuItemProps = {
  item: NavMenuItemType;
  onClick?: () => void;
  divider?: boolean;
};

export const SideNavigationItem = ({ item, divider, onClick }: SideNavMenuItemProps) => {
  return (
    <div>
      <button className={styles.menuButton} onClick={onClick}>
        <div className={styles.innerContainer}>
          <Typography
            variant={Typography.VARIANT.B3}
            align={Typography.ALIGN.LEFT}
            color={Typography.COLOR.SECONDARY}
            className={styles.displayName}
          >
            {item.displayName}
          </Typography>
          <Icon icon={ICONS_ENUM.NAVIGATION_CHEVRON_RIGHT} className={styles.menuIcon} />
        </div>
      </button>
      {divider && <Divider className={styles.divider} />}
    </div>
  );
};
